import React from 'react';
class Thumbnail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      thumbnailURL: ''
    };
  }

  updateThumbnailURL(event) {
    this.setState({
      thumbnailURL: event.target.value
    });
  }

  render() {
    return(
      <div className = "embed-group embed-thumbnail">
        <div className = "embed-thumbnail-url">
          <input
            type = "url"
            name = "thumbnail:url"
            placeholder = "Thumbnail URL"
            value = {this.state.thumbnailURL}
            onChange = {event => this.updateThumbnailURL(event)}
          />
        </div>
      </div>
    );
  }
}

export default Thumbnail;
